import CallView from './CallView';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
    {
        path: frontendURL('accounts/:accountId/calls'),
        name: 'calls',
        roles: ['administrator'], //TODO: add other roles: agent, supervisor, seller
        component: CallView,
        props: () => {
            return {};
        },
    },
];
